import React, { useState, Component } from 'react';
// import '../../styles/spacing'



class Toast extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);
   
    this.state = {
      visibility : 'off'
    };
  }

  // componentDidUpdate() {
  //   console.log(this.state.visibility)
  //   setTimeout(() => {
  //     this.setState({visibility: "on"})
  //   }, 1000)

  // }


  

  render() {
    // const { content, cx, absolute, center } = this.props;
    // console.log(this.props.checked)

    //TODO TOGGLE TOAST CLASS AFTER 5 SECONDS
  
    return (
      <p className={`ba pos-fixed bg pa-s br-small ${this.props.checked ? 'toast-on' : 'toast-off'}`}>PØLSE AKTIV</p>
    
    );
  
  }
}


export default Toast;

// pos-absolute bottom-medium center-absolute left-50